import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiErrorPayload, isApiErrorPayload } from '../../../../../submodules/engine-common/api-error-payload';
import { NotificationDataService } from '../../angular-ui-common/notification-data.service';
import { SecurityDataService } from '../security-data.service';
import { Router } from '@angular/router';

@Injectable()
export class RestErrorManager {

  constructor(
    private _injector: Injector
  ) { }

    manageError = (error,  options?:{
                                    callback?:Function
                                    }
                                    ):'JUICE_SERVER_ERROR' | 'GENERIC_ERROR' => {
      //The returned error OBJECT
      let errorPayload: any;
      //TODO: sometimes here there is an object and sometimes a string (the API always return a string...)
      try {
        errorPayload = JSON.parse(error.error);
      } catch (e) { //error.error non è una stringa 
        errorPayload = error.error;
        if(!isApiErrorPayload(errorPayload)){
          console.log('manageRestInvocationError() ', error);
          this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("GENERIC_ERROR"));
          return 'GENERIC_ERROR'; //può essere un errore lato client oppure un errore restituito da API di terze parti
        }
      }
      //Manage ApiErrorPayload
      
      if((errorPayload as ApiErrorPayload).status==401){
        this._injector.get(SecurityDataService).cleanUserSession();
        if(options && options.callback) //In caso di logout viene passato a true
          options.callback();
        else{
          this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("AUTH.SESSION_EXPIRED"));
          this._injector.get(Router).navigate(["/login"])
        }
          
      }else{
        this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant((errorPayload as ApiErrorPayload).errorCode,(errorPayload as ApiErrorPayload).keyValueParams));
        if(options && options.callback) //In caso di logout viene passato a true
          options.callback();
      }
      
      return 'JUICE_SERVER_ERROR';
    }  
}